import { supabase } from '../supabaseClient';
import { uid } from '../utils/format';

/* Accès aux données « clients ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchClientsByStatus() {
  return supabase
    .from('clients')
    .select('*')
    .eq('statut', 'actif')
    .order('nom', { ascending: true })
    .order('id');
}

export function setClientArchived(id, archive) {
  return supabase
    .from('clients')
    .update({ archived_at: archive ? new Date().toISOString() : null })
    .eq('id', id);
}

export function fetchClientSummaries() {
  return supabase.from('clients').select('id,nom,statut,secteurs');
}

export function insertProspectFromTender(f, newClientId) {
  return supabase.from('clients').insert({
    id: newClientId,
    nom: f.newClientNom.trim(),
    jira_project_key: '',
    statut: 'prospect',
    origine: "Appel d'offre",
    secteurs: f.newClientSecteurs || [],
  });
}

export function fetchClientJiraKey(m) {
  return supabase.from('clients').select('jira_project_key').eq('id', m.client_id).maybeSingle();
}

export function activateClient(globalKey, m) {
  return supabase
    .from('clients')
    .update({ statut: 'actif', ...(globalKey ? { jira_project_key: globalKey } : {}) })
    .eq('id', m.client_id);
}

export function insertProspectFromDeal(n, newClientId) {
  return supabase.from('clients').insert({
    id: newClientId,
    nom: n.nom.trim(),
    jira_project_key: '',
    statut: 'prospect',
    origine: n.origine || null,
    secteurs: n.secteurs || [],
    contact_prenom: n.contact_prenom || null,
    contact_nom: n.contact_nom || null,
    contact_tel: n.contact_tel || null,
    contact_email: n.contact_email || null,
  });
}

export function fetchContacts() {
  return supabase.from('clients').select('*').order('nom');
}

export function patchClient(id, patch) {
  return supabase.from('clients').update(patch).eq('id', id);
}

export function updateContact(c, row) {
  return supabase.from('clients').update(row).eq('id', c.id);
}

export function insertContact(row) {
  return supabase.from('clients').insert({ id: uid(), jira_project_key: '', ...row });
}

export function deleteContact(c) {
  return supabase.from('clients').delete().eq('id', c.id);
}

export function updateClient(cData, modalData) {
  return supabase.from('clients').update(cData).eq('id', modalData.clientId);
}

export function insertClient(cData, newId) {
  return supabase.from('clients').insert({ id: newId, ...cData });
}

export function fetchClient(client) {
  return supabase.from('clients').select('*').eq('id', client.id).single();
}

export function deleteClient(client) {
  return supabase.from('clients').delete().eq('id', client.id);
}

export function upsertClients(c) {
  return supabase
    .from('clients')
    .upsert({ id: c.id, nom: c.nom, jira_project_key: c.jira_project_key || '' });
}
